import { AutosizeTextareas } from "./autosize-textareas";
import { ExclusiveCheckboxes } from "./exclusive-checkboxes";
import { LocalWhen } from "./local-when";
import { OffCanvas } from "./off-canvas";
import { RecommendationFilters } from "./recommendation-filters";

AutosizeTextareas.init();
ExclusiveCheckboxes.init();
LocalWhen.init();
OffCanvas.init();
RecommendationFilters.init();
